import { GridSize, ResponsiveStyleValue } from '@mui/system';

export const EditGridLayout: ResponsiveStyleValue<GridSize> = {
  xs: 12,
  sm: 12,
  md: 6,
};
export const CreateGridLayout: ResponsiveStyleValue<GridSize> = {
  xs: 12,
  sm: 6,
};
